import { Message } from "element-ui";
const axios = require("axios");
import config from "@/config.js";

// 创建axios实例
export const instance = axios.create({
  baseURL: config.server,
  timeout: 100000,
});
export var http = function (baseUrl, api, method, props) {
  if (!baseUrl || !api || !method) throw new Error("参数错误");
  switch (baseUrl) {
    case "api1":
      // instance.defaults.baseURL = "https://56gangkou.com/mob_api";
      break; //正式环境
    // case "api2": instance.defaults.baseURL = "https://56gangkou.com/mob_api"; break;//智哥 
    // case "api1": instance.defaults.baseURL = "http://192.168.0.42:9210"; break;
    // case "api2": instance.defaults.baseURL = "http://192.168.0.42:9210"; break;
    // case "api1": instance.defaults.baseURL = "http://192.168.0.61:9010"; break;
    // case "api2": instance.defaults.baseURL = "http://192.168.0.61:9010"; break;
    // case "api1": instance.defaults.baseURL = "http://192.168.0.75:9010"; break;//测试环境
    // case "api2": instance.defaults.baseURL = "http://192.168.11.10:9010"; break;
    // case "api1": instance.defaults.baseURL = "http://111.160.87.82:8037"; break;//测试环境
    // case "api2": instance.defaults.baseURL = "http://111.160.87.82:8037"; break;
  }
  instance.defaults.responseType = "json";
  switch (api) {
    case "/captcha.jpg":
      instance.defaults.responseType = "arraybuffer";
      break;
    case "/driver/rfid/uploadFileAndImportData":
      instance.defaults.headers.post["Content-Type"] = "multipart/form-data";
      break;
    case "/driver/dispatchtruckrefund/exportList":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //退款确认导出
    case "/csvanalysis/csv/truckanalysisexsx":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //派车对账导出

    case "/driver/dispatchtruck/exportlistdetails":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //作业详情导出
    case "/driver/dispatchtruckdrivercar/exportlistdetails":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //作业详情导出
    case "/api/replenish/DriverCarSpeedAlarm/exportCarSpeedAlarmlist":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //作业详情导出
    case "/statistics/refund/exportRefundDetails":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break;
    case "/exchangeWeight/list":
      instance.defaults.timeout = 180000;
      break;
    case "/driver/dispatchtruckrefund/refundExaminationPassed":
      instance.defaults.timeout = 180000;
      break;
    case "/csvanalysis/csv/truckanalysis":
      instance.defaults.timeout = 180000;
      break;
    case "/api/replenish/log/exportPileDatail":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //充电桩导出
    case "/api/replenish/log/exportEnergyLoglist":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //充电记录导出
    case "/driver/dispatchtruck/exportDispatchTruckListByPno":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //派车列表导出
    case "/fleet/plan/exportPlanListPcWorkReport":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //作业查询计划
    case "/home/statistics/exportCarWorkSearch":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //作业查询车队车辆
    case "/driver/car/exportCarList":
      instance.defaults.responseType = "blob";
      instance.defaults.timeout = 180000;
      break; //作业查询车队车辆
  }
  if (method === "get") {
    if (props) return instance.get(api, { params: props });
    return instance.get(api);
  } else if (method === "post") {
    return instance.post(api, props);
  }
};

export const $request = axios.create({
  // baseURL: "https://56gangkou.com",
  // baseURL: "http://192.168.11.10:9010",
  baseURL: config.server,
  timeout: 15000,
});
$request.interceptors.request.use(
  (config) => {
    const user = window.sessionStorage.getItem("user");
    if (user) {
      config.headers["token"] = JSON.parse(decodeURIComponent(user)).token;
    }
    return config;
  },
  (error) => {
    console.error("request -> error", error);
  }
);
$request.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      return response.data;
    } else {
      throw response;
    }
  },
  (error) => {
    console.dir(error)
    let msg = "error";
    if (error == "Error: Request failed with status code 404") {
      msg = "请求方法不存在";
    }
    if (typeof error == "string") {
      Message.error(error);
    }
    Message.error(msg);
  }
);
